import ProgressOfContent from './ProgressOfContent'

export default ProgressOfContent
